module.exports = __webpack_public_path__ + "media/images/gallery/constellations/crater/crt_snr-632026a854af0ac61fda3f2285dfe40f.gif";